var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0912 22.0775C17.7408 21.7278 17.3232 21.4526 16.8636 21.2686L2.32531 15.4386C2.15172 15.3689 2.0036 15.2478 1.90082 15.0916C1.79803 14.9353 1.74551 14.7513 1.7503 14.5644C1.75509 14.3774 1.81696 14.1964 1.92761 14.0456C2.03826 13.8948 2.19239 13.7814 2.36931 13.7207L37.2026 1.80408C37.3651 1.7454 37.5409 1.73421 37.7095 1.7718C37.878 1.80939 38.0324 1.89421 38.1546 2.01634C38.2767 2.13847 38.3615 2.29285 38.3991 2.46143C38.4367 2.63001 38.4255 2.8058 38.3668 2.96825L26.4501 37.8016C26.3895 37.9785 26.2761 38.1326 26.1253 38.2433C25.9745 38.3539 25.7935 38.4158 25.6065 38.4206C25.4195 38.4254 25.2356 38.3729 25.0793 38.2701C24.923 38.1673 24.802 38.0192 24.7323 37.8456L18.9023 23.3036C18.7175 22.8443 18.4416 22.4272 18.0912 22.0775ZM18.0912 22.0775L38.1486 2.02408",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.0e7efa71743d02d99264838a5e274018.svg";
export { ForwardRef as ReactComponent };